// Login Error Messages
//
// Raw API failures (backend strings, axios messages) must never be rendered
// on the login form — they are technical, inconsistent, and can leak internal
// details. Every login failure is mapped to one of these friendly messages.

export const LOGIN_ERROR_MESSAGES = {
  INVALID_CREDENTIALS: 'Please check your username and password and try again.',
  NETWORK: 'Unable to connect to the server. Please check your internet connection and try again.',
  GENERIC: 'Something went wrong while signing in. Please try again.',
};

export const friendlyLoginError = (payload) => {
  const raw =
    typeof payload === 'string'
      ? payload
      : payload?.error || payload?.message || payload?.detail || '';

  if (/invalid credentials|invalid username|invalid password|unauthorized/i.test(raw)) {
    return LOGIN_ERROR_MESSAGES.INVALID_CREDENTIALS;
  }
  if (/network error|failed to fetch|timeout|econnrefused/i.test(raw)) {
    return LOGIN_ERROR_MESSAGES.NETWORK;
  }
  return LOGIN_ERROR_MESSAGES.GENERIC;
};

export default friendlyLoginError;
